var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useDispatch } from 'react-redux';
import FormData from 'app/components/Form/FormData/FormData.jsx';
import { ModalConfirmForm } from 'app/components/Modal';
import { createUserFromOffice } from 'app/store/reducers/users';
import { generatePassphrase } from 'app/pages/Admin/Offices/utils/passwordGenerator';
import { openModal, MUIModal } from 'app/components/Modal';
import ModalCredentials from 'app/pages/Admin/Offices/ModalCredentials/ModalCredentials';
const ModalCreateUser = (props) => {
    const { officeId } = props, rest = __rest(props, ["officeId"]);
    const password = generatePassphrase();
    const dispatch = useDispatch();
    const onSave = (data) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const login = `${data.firstname}.${data.lastname}`.toLowerCase();
            const user = {
                assetType: 'us',
                password: password,
                parent: officeId,
                name: login,
                attributes: {
                    email: data.email,
                },
            };
            const res = yield dispatch(createUserFromOffice(user));
            openModal(_jsx(MUIModal, Object.assign({ title: "User credentials", hideCancel: true, validateLabel: "Close" }, rest, { children: _jsx(ModalCredentials, { login: login, password: password }) })));
            return res;
        }
        catch (error) {
            return error;
        }
    });
    return (_jsx(ModalConfirmForm, Object.assign({ title: "Create new user", validateLabel: "Create user" }, rest, { children: _jsx(FormData, { properties: [
                {
                    key: 'firstname',
                    label: 'Firstname',
                    type: FormData.types.string,
                    elementProps: { isRequired: true },
                },
                {
                    key: 'lastname',
                    label: 'Lastname',
                    type: FormData.types.string,
                    elementProps: { isRequired: true },
                },
                {
                    key: 'email',
                    label: 'Email',
                    type: FormData.types.email,
                    elementProps: { isRequired: true },
                },
            ], onSave: onSave, flashNotifSuccessLabel: "User created" }) })));
};
export default ModalCreateUser;
